import { EmopTableProHeaderSortOrderEnum } from "./EmopTableProHeaderSortOrderEnum";


export class EmopTableProHeaderSortClass {
  /**
   * 排序函数，前端排序使用一个函数(参考 Array.sort 的 compareFunction)，服务端排序时传入 true
   */
  fn: Function | true;
  /**
   * 支持的排序方式，取值为 'ascend', 'descend', null
   */
  orderList?: EmopTableProHeaderSortOrderEnum[] = [EmopTableProHeaderSortOrderEnum.ascend, EmopTableProHeaderSortOrderEnum.descend, EmopTableProHeaderSortOrderEnum.null];
  /**
   * 当前排序状态
   */
  order?: 'ascend' | 'descend' | null = null;
  /**
   * 排序的优先级
   */
  seq?: number | false = null;

  constructor(constructorData: EmopTableProHeaderSortClass | true) {
    if (typeof constructorData !== 'boolean') {
      for (const key in constructorData) {
        if (constructorData[key] !== undefined) this[key] = constructorData[key];
      }
    }
  }
}